const getPageCount = (totalItems: number, limit: number) => {
  return Math.ceil(totalItems / limit) || 0;
};

export default getPageCount;
